(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fermorin-promo-countdown')) {
    class FermorinPromoCountdown extends HTMLElement {
      constructor() {
        super();
        this.duration = 24 * 60 * 60 * 1000;
        this.interval = null;
        this.deadline = 0;
        this.lastAccessibleMinute = '';
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      }

      connectedCallback() {
        this.output = this.querySelector('[data-fermorin-countdown-output]');
        this.values = {
          days: this.querySelector('[data-fermorin-countdown-days]'),
          hours: this.querySelector('[data-fermorin-countdown-hours]'),
          minutes: this.querySelector('[data-fermorin-countdown-minutes]'),
          seconds: this.querySelector('[data-fermorin-countdown-seconds]'),
        };
        if (!this.output || Object.values(this.values).some((value) => !value)) return;

        this.storageKey = this.dataset.storageKey || 'fermorin-promo-countdown-deadline-v1';
        this.ariaPrefix = this.dataset.ariaPrefix || 'Sale ends in';
        this.deadline = this.readDeadline();

        if (!Number.isFinite(this.deadline) || this.deadline <= Date.now()) {
          this.resetDeadline(Date.now());
        }

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      readDeadline() {
        try {
          return Number(window.localStorage.getItem(this.storageKey));
        } catch (error) {
          return this.deadline;
        }
      }

      writeDeadline(value) {
        this.deadline = value;

        try {
          window.localStorage.setItem(this.storageKey, String(value));
        } catch (error) {
          return;
        }
      }

      resetDeadline(now) {
        this.writeDeadline(now + this.duration);
      }

      start() {
        this.stop();
        this.update();

        if (!document.hidden) {
          this.interval = window.setInterval(() => this.update(), 1000);
        }
      }

      stop() {
        if (!this.interval) return;
        window.clearInterval(this.interval);
        this.interval = null;
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stop();
          return;
        }

        this.start();
      }

      update() {
        const now = Date.now();

        if (this.deadline <= now) {
          this.resetDeadline(now);
        }

        const totalSeconds = Math.max(0, Math.ceil((this.deadline - now) / 1000));
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const values = { days, hours, minutes, seconds };

        Object.entries(values).forEach(([unit, value]) => {
          const formattedValue = String(value).padStart(2, '0');
          if (this.values[unit].textContent !== formattedValue) {
            this.values[unit].textContent = formattedValue;
          }
        });

        const accessibleMinute = `${days}:${hours}:${minutes}`;
        if (accessibleMinute !== this.lastAccessibleMinute) {
          this.output.setAttribute(
            'aria-label',
            `${this.ariaPrefix} ${days} days ${hours} hours ${minutes} minutes`,
          );
          this.lastAccessibleMinute = accessibleMinute;
        }
      }
    }

    customElements.define('fermorin-promo-countdown', FermorinPromoCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fermorin-conversion-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fermorin-sticky-buy')) {
    customElements.define('fermorin-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.hero = document.getElementById(this.dataset.heroId);
        this.stickyHeader = document.querySelector('sticky-header');
        this.headerSection = document.querySelector('.section-header');
        this.headerButtons = [];
        this.mobileHosts = [];
        this.ticking = false;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        this.queueDelayedUpdate = this.queueDelayedUpdate.bind(this);
        this.mountHeaderButtons();
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate);
        document.addEventListener('click', this.queueDelayedUpdate, true);
        document.addEventListener('toggle', this.queueUpdate, true);
        if (this.headerSection) this.headerSection.addEventListener('transitionend', this.queueUpdate);
        this.overlayObserver = new MutationObserver(this.queueUpdate);
        this.overlayObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });
        document.querySelectorAll('cart-drawer, modal-dialog, product-modal, details.drawer').forEach((overlay) => {
          this.overlayObserver.observe(overlay, {
            attributes: true,
            attributeFilter: ['class', 'open', 'aria-hidden']
          });
        });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        document.removeEventListener('click', this.queueDelayedUpdate, true);
        document.removeEventListener('toggle', this.queueUpdate, true);
        if (this.headerSection) this.headerSection.removeEventListener('transitionend', this.queueUpdate);
        this.overlayObserver.disconnect();
        this.headerButtons.forEach((button) => button.remove());
        this.mobileHosts.forEach((host) => {
          host.hidden = true;
          host.setAttribute('aria-hidden', 'true');
        });
        if (this.stickyHeader) this.stickyHeader.preventHide = false;
        document.body.classList.remove('fermorin-sticky-buy-visible');
      }

      mountHeaderButtons() {
        const sourceButton = this.querySelector('.fermorin-sticky-buy__button');
        if (!sourceButton) return;

        document.querySelectorAll('sticky-header [data-fermorin-sticky-cta-host]').forEach((container) => {
          if (container.querySelector('.fermorin-header-buy-button')) return;
          const button = sourceButton.cloneNode(true);
          button.className = 'fermorin-header-buy-button';
          button.hidden = true;
          button.setAttribute('aria-hidden', 'true');
          if (container.dataset.fermorinStickyCtaHost === 'desktop') {
            container.insertBefore(button, container.firstChild);
          } else {
            container.appendChild(button);
          }
          this.headerButtons.push(button);

          if (container.dataset.fermorinStickyCtaHost === 'mobile') {
            container.hidden = true;
            container.setAttribute('aria-hidden', 'true');
            this.mobileHosts.push(container);
          }
        });

        this.dataset.headerMounted = this.headerButtons.length ? 'true' : 'false';
      }

      queueDelayedUpdate() {
        this.queueUpdate();
        window.setTimeout(this.queueUpdate, 240);
      }

      queueUpdate() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this.update);
      }

      update() {
        this.ticking = false;
        if (!this.hero) return;
        const initialHeaderBottom = this.headerSection ? Math.max(0, this.headerSection.getBoundingClientRect().bottom) : 0;
        const pastHero = this.hero.getBoundingClientRect().bottom <= initialHeaderBottom;
        const bodyLocksPage = document.body.classList.contains('jm-mfp-is-open') ||
          document.body.classList.contains('fixed-position') ||
          Array.from(document.body.classList).some((className) => className.indexOf('overflow-hidden') === 0);
        const overlayOpen = bodyLocksPage || Boolean(document.querySelector(
          '.cart-drawer-container.active, cart-drawer.active, cart-drawer[open], .popup-modal[open], details.menu-opening, dialog[open]'
        ));
        const visible = pastHero && !overlayOpen;

        if (this.stickyHeader) {
          this.stickyHeader.preventHide = visible;
          if (visible && typeof this.stickyHeader.reveal === 'function') {
            this.stickyHeader.reveal();
          }
        }

        const headerRect = this.headerSection ? this.headerSection.getBoundingClientRect() : null;
        const headerHidden = this.headerSection && this.headerSection.classList.contains('shopify-section-header-hidden');
        const headerOnscreen = Boolean(headerRect && headerRect.bottom > 0 && !headerHidden);
        const hasHeaderHosts = this.headerButtons.length > 0;
        const showHeaderCta = visible && headerOnscreen && hasHeaderHosts;
        const showFallback = visible && (!headerOnscreen || !hasHeaderHosts);
        const fallbackTop = headerOnscreen && headerRect ? Math.max(0, headerRect.bottom) : 0;

        this.style.setProperty('--fermorin-sticky-top', `${fallbackTop}px`);
        this.headerButtons.forEach((button) => {
          button.hidden = !showHeaderCta;
          button.setAttribute('aria-hidden', showHeaderCta ? 'false' : 'true');
        });
        this.mobileHosts.forEach((host) => {
          host.hidden = !showHeaderCta;
          host.setAttribute('aria-hidden', showHeaderCta ? 'false' : 'true');
        });

        this.hidden = !showFallback;
        this.toggleAttribute('inert', !showFallback);
        this.classList.toggle('is-visible', showFallback);
        if (visible && this.headerSection && (!this.stickyHeader || typeof this.stickyHeader.reveal !== 'function')) {
          this.headerSection.classList.add('shopify-section-header-sticky', 'animate');
          this.headerSection.classList.remove('shopify-section-header-hidden');
        }
        document.body.classList.toggle('fermorin-sticky-buy-visible', visible);
        this.setAttribute('aria-hidden', showFallback ? 'false' : 'true');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

    if (!window.FermorinDisableProductEnhancements && !(window.Shopify && window.Shopify.designMode)) {
    if (!window.FermorinProductPurchaseOptions) {
      window.FermorinProductPurchaseOptions = true;
      let purchaseOptionsFrame;
      let purchaseOptionsObserver;

      const arrangePurchaseOptions = () => {
        const root = document.querySelector('[id^="MainProduct-"]');
        const subscription = root?.querySelector(
          '.sealsubs-container .sls-option-container[data-selling-plan-group]'
        );
        const subscriptionReady = /subscribe/i.test(subscription?.textContent || '');
        if (!subscriptionReady) return false;

        const moreInfo = root.querySelector('.sealsubs-container .sls-more-info-container');
        const detailsLink = moreInfo?.querySelector('a');
        if (
          subscription &&
          moreInfo &&
          detailsLink &&
          /subscription details/i.test(detailsLink.textContent || '') &&
          !moreInfo.classList.contains('fermorin-subscription-help')
        ) {
          subscription.appendChild(moreInfo);
          moreInfo.classList.add('fermorin-subscription-help');
          detailsLink.textContent = '?';
          detailsLink.setAttribute('aria-label', 'Subscription details');
          detailsLink.setAttribute('title', 'Subscription details');
        }

        return moreInfo?.parentElement === subscription &&
          moreInfo.classList.contains('fermorin-subscription-help');
      };

      const schedulePurchaseOptions = () => {
        if (purchaseOptionsFrame) return;
        purchaseOptionsFrame = requestAnimationFrame(() => {
          purchaseOptionsFrame = null;
          if (arrangePurchaseOptions()) purchaseOptionsObserver?.disconnect();
        });
      };

      const productRoot = document.querySelector('[id^="MainProduct-"]');
      if (productRoot) {
        purchaseOptionsObserver = new MutationObserver(schedulePurchaseOptions);
        purchaseOptionsObserver.observe(productRoot, { childList: true, subtree: true });
        schedulePurchaseOptions();
      }
    }

    if (!window.FermorinReviewAvatars) {
      window.FermorinReviewAvatars = true;
      let reviewAvatarFrame;

      const decorateReviewAvatars = () => {
        document.querySelectorAll('#judgeme_product_reviews .jdgm-rev').forEach((review) => {
          const author = review.querySelector('.jdgm-rev__author');
          const icon = review.querySelector('.jdgm-rev__icon');
          if (!author || !icon || icon.dataset.initials) return;

          const nameParts = author.textContent.trim().split(/\s+/).filter(Boolean);
          if (!nameParts.length) return;

          const firstInitial = nameParts[0].charAt(0);
          const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) : '';
          icon.dataset.initials = `${firstInitial}${lastInitial}`.toUpperCase();
          icon.setAttribute('aria-hidden', 'true');
        });
      };

      const scheduleReviewAvatarDecoration = () => {
        if (reviewAvatarFrame) return;
        reviewAvatarFrame = requestAnimationFrame(() => {
          reviewAvatarFrame = null;
          decorateReviewAvatars();
        });
      };

      const reviewAvatarObserver = new MutationObserver(scheduleReviewAvatarDecoration);
      reviewAvatarObserver.observe(document.body, { childList: true, subtree: true });
      scheduleReviewAvatarDecoration();
    }

    if (!window.FermorinReviewImageScroll) {
      window.FermorinReviewImageScroll = true;
      const reviewModalBody = document.body;
      const reviewModalRoot = document.documentElement;
      const reviewPictureSelector = '#judgeme_product_reviews .jdgm-rev__pic-link, #judgeme_product_reviews .jdgm-rev__pic-img, #judgeme_product_reviews .jdgm-rev__pic';
      let reviewModalWasOpen = reviewModalBody.classList.contains('jm-mfp-is-open');
      let savedReviewScrollY = null;
      let reviewPictureControl = null;
      let previousRootScrollBehavior = '';
      let previousBodyScrollBehavior = '';
      let reviewScrollRestoreTimer;

      const disableReviewSmoothScroll = () => {
        reviewModalRoot.style.scrollBehavior = 'auto';
        reviewModalBody.style.scrollBehavior = 'auto';
      };

      const captureReviewPosition = (target) => {
        const picture = target.closest(reviewPictureSelector);
        if (!picture) return;

        if (savedReviewScrollY === null) {
          savedReviewScrollY = window.scrollY;
          previousRootScrollBehavior = reviewModalRoot.style.scrollBehavior;
          previousBodyScrollBehavior = reviewModalBody.style.scrollBehavior;
        }

        reviewPictureControl = picture.closest('.jdgm-rev__pic-link') || picture;
        disableReviewSmoothScroll();
      };

      document.addEventListener('pointerdown', (event) => {
        if (event.target instanceof Element) captureReviewPosition(event.target);
      }, true);

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (document.activeElement instanceof Element) captureReviewPosition(document.activeElement);
      }, true);

      const restoreReviewPosition = () => {
        if (savedReviewScrollY === null) return;

        const targetScrollY = savedReviewScrollY;
        const focusTarget = reviewPictureControl;
        const restore = () => window.scrollTo(0, targetScrollY);

        disableReviewSmoothScroll();
        restore();
        if (focusTarget instanceof HTMLElement) focusTarget.focus({ preventScroll: true });

        requestAnimationFrame(() => {
          restore();
          requestAnimationFrame(restore);
        });

        clearTimeout(reviewScrollRestoreTimer);
        reviewScrollRestoreTimer = setTimeout(() => {
          restore();
          reviewModalRoot.style.scrollBehavior = previousRootScrollBehavior;
          reviewModalBody.style.scrollBehavior = previousBodyScrollBehavior;
          savedReviewScrollY = null;
          reviewPictureControl = null;
        }, 300);
      };

      const reviewModalObserver = new MutationObserver(() => {
        const reviewModalIsOpen = reviewModalBody.classList.contains('jm-mfp-is-open');

        if (reviewModalIsOpen && !reviewModalWasOpen) {
          if (savedReviewScrollY === null) {
            const lockedTop = Number.parseFloat(reviewModalBody.style.top);
            savedReviewScrollY = Number.isFinite(lockedTop) && lockedTop < 0 ? Math.abs(lockedTop) : window.scrollY;
            previousRootScrollBehavior = reviewModalRoot.style.scrollBehavior;
            previousBodyScrollBehavior = reviewModalBody.style.scrollBehavior;
          }
          disableReviewSmoothScroll();
        }

        if (!reviewModalIsOpen && reviewModalWasOpen) restoreReviewPosition();
        reviewModalWasOpen = reviewModalIsOpen;
      });

      reviewModalObserver.observe(reviewModalBody, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();
})();
